export default "__VITE_ASSET__4bde8539__"